import { defineMessages } from 'react-intl';

export const i18n: {
	groupLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chat: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	search: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	groupLabel: {
		id: 'search-page.common.mode-toggle.groupLabel',
		defaultMessage: 'Switch between chat and search',
		description:
			'Accessible label for the group of buttons that switch between chat and search modes',
	},
	chat: {
		id: 'search-page.common.mode-toggle.chat',
		defaultMessage: 'Chat',
		description: 'Label for the toggle button that switches the page to Rovo chat mode',
	},
	search: {
		id: 'search-page.common.mode-toggle.search',
		defaultMessage: 'Search',
		description: 'Label for the toggle button that switches the page to search mode',
	},
});
